import '../scss/style.scss';

import 'browsernizr/test/css/rgba';
import 'browsernizr/test/file/filesystem';
import 'browsernizr/test/websockets';
import svg4everybody from 'svg4everybody/dist/svg4everybody'

/*Shared Elements*/
import Menu from './shared/menu.js';

/*Site wiegets*/
import VideoScroll from './blocks/video-scroll.js';
import BlockHero from './blocks/block_hero.js';
import BlockArrowDown from './blocks/block_arrow_down.js';
import BlockPreviewMenu from './blocks/block_preview_menu.js';
import BlockSlideShow from './blocks/block_slideshow.js';
import BlockParagraphLong from './blocks/block_paragraph_long.js';
import BlockDistribution from './blocks/block_distribution.js';
import BlockModalPopup from './blocks/block_modal_popup.js';
import BlockVideoReel from './blocks/block_video_reel.js';

/*Site Pages*/
import PageContact from './pages/contact.js';
import PageLeadership from './pages/leadership-page.js';
import PageDistribution from './pages/distribution-page.js';
import PageHome from './pages/home-page.js'
import PageLifeAt3Media from './pages/lifeat-at-3media-page.js'

/*Modernizr*/
import fullpage from 'fullpage.js';

import Modernizr from 'browsernizr';
import { event } from 'jquery';


// Set global variables
window.WINDOW_WIDTH = $(window).width();
window.WINDOW_HEIGHT = $(window).height();
window.BREAK_XL = 1200;
window.BREAK_LG = 992;
window.BREAK_MD = 768;
window.BREAK_SM = 576;
window.BREAK_XS = 480;



var SCROLLING_SPEED = 700;

$(document).ready(function() {

	// Lets get the SVGs in:
	svg4everybody();


	// Initialise the menu
	let menu = new Menu($('.header'))

	// Only initialise the class if the widget exists on the page.
	let blockVideo;
	let hero;
	let blockParagraphLong;
	let arrowDown;
	let previewMenu;
	let pageContact;
	let pageLeadership;
	let pageDistribution;
	let pageHome;
	let slideShow;
	let modalPopup;
    let pageLifeAt3Media;
	let blockVideoReel;
	
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	let customCursor = $(document).find('.cursor');
	let mainLogo = $(document).find('.header__logo-desk').find('.cls-1');
	
	/////global custom cursor
	var cursor = $('.cursor');

	////////// hide custom cursor on touch screen devices
	function is_touch_device() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}


	if (is_touch_device() == true) {
		$(customCursor).css('display', 'none');
		$('html').css('cursor', 'initial');
		$('a').css('cursor', 'pointer');
	}else{
		$(window).on('mousemove', function(e) {
			cursor.css({
				top: e.clientY - cursor.height() / 2,
				left: e.clientX - cursor.width() / 2
	
				// top: e.pageY - cursor.height() / 2,
				// left: e.pageX - cursor.width() / 2
			});
		});
	
		$(window).on('mouseleave', function() {
			cursor.css({
				opacity: "0"
			});
		})
		.on('mouseenter', function() {
			cursor.css({
				opacity: "1"
			});
		});

		

		$(window).on('mousedown', function(event) {
            // cursor.css({
			// 	transform: "scale(.2)",
            // });
			if (event.which === 1) {
				cursor.css({
					transform: "scale(.2)",
				});
				// console.log("left")
			}
			else {
				cursor.css({
					transform: "scale(1)",
				});
			}
			
		})
		.on('mouseup', function(event) {
			if (event.which === 1) {
				cursor.css({
					transform: "scale(1)",
				});
			}
			else {
				cursor.css({
					transform: "scale(1)",
				});
			}
           
		});
	}


    
    if( window.location.pathname !== "/"){

        document.querySelector('.header__logo-desk').style.opacity = "1"
        window.addEventListener('resize', (e) => {
            if (window.innerWidth < 768){
                document.querySelector('.header__logo-desk').style.opacity = "0"
            }else{
               document.querySelector('.header__logo-desk').style.opacity = "1"
            }
        })

        document.querySelector('.nav-icon-wrapper').style.opacity = "1"
	} 
	////hover effect logo

	if(document.querySelector(".header__logo-desk").style.opacity = '1') {

		document.querySelector(".header__logo-desk").onmouseover = function(event) {
			document.querySelector(".header__logo-desk").style.opacity = '0.7';
		};

		document.querySelector(".header__logo-desk").onmouseout = function(event) {
			document.querySelector(".header__logo-desk").style.opacity = '1';
		};

	}


	///////////black logo for all the pages from the footer menu

	var footerPagesAnchors = $('#menu-footer-menu a').map( function( ind, val) {
		
		let anch = $(val).attr('href');

		if (window.location.href.indexOf(anch) > -1) {
			$(mainLogo).css('fill', '#221f1f')
		}
	});

	//////// Browser check



	////////modules logic
	

	if($('body').hasClass('contact')){

		pageContact = new PageContact($(this));
		
	}
	if($('body').hasClass('leadership')){

		pageLeadership = new PageLeadership($(this));
		
	}
	if($('body').hasClass('distribution')){

		pageDistribution = new PageDistribution($(this));
		
	}

	if($('body').hasClass('life-at-all3media')){

		pageLifeAt3Media = new PageLifeAt3Media($(this).find('.life_at_all3'));
		
	}
	if($('body').hasClass('home')){

		pageHome = new PageHome($(this).find('.home_wrapper'));
		
	}

	$('body').find('.block').each(function(index){

		if($(this).hasClass('block_distribution')){

			blockVideo = new BlockDistribution($(this));
			
		}

		if($(this).hasClass('block_video-scroll')){

			blockVideo = new VideoScroll($(this));
			
		}
		if($(this).hasClass('block_hero')){

			hero = new BlockHero($(this));
			
		}

		if($(this).hasClass('block_paragraph_long')){

			blockParagraphLong = new BlockParagraphLong($(this));
			
		}


		if($(this).hasClass('block_arrow')){

			arrowDown = new BlockArrowDown($(this));
			
		}

		if($(this).hasClass('block_preview_menu')){

			previewMenu = new BlockPreviewMenu($(this));
			
		}

		if($(this).hasClass('block_slideshow')){

			slideShow = new BlockSlideShow($(this));
			

		}
		if($(this).hasClass('block_modal_popup')){

			modalPopup = new BlockModalPopup($(this));
			
		}

	})
});